import React, { Component } from "react";
import moment from "moment";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import { withSnackbar } from "react-simple-snackbar";

import redux from "../common/Redux";
// import { AdminHomeScreen } from "../screens";
import { AdminNavigation } from "../components";
import categoryRoutes from "./category.routes";
import HotelRouts from "./hotel.routes";
import MenuRoutes from "./menu.routes";
import OrderRoutes from "./order.routes";
import BookingRoutes from "./booking.routes";
import FloorRoutes from "./floor.routes";
import NotFoundScreen from "../screens/NotFoundScreen";
import DashboardRoutes from "./dashboard.routes";
import UsersRoutes from "./user.routes";
import digitalTokenRouts from "./digitalToken.routes";
import SettingRoutes from "./setting.routes";
import qrcodeRoutes from "./qrcode.routes"
import {UserListScreen,UserListViewScreen,QRCodeScreen,ReviewScreen,StatusConfigScreen,TimingScreen,TaxTokenScreen} from "../screens/SettingScreens";
import GalleryScreen from "../screens/SettingScreens/GalleryScreen";
// import settingsScreen from "../screens/SettingScreens/SettingScreenContainer";
import KotRoutes from "./kot.routes";
import InventoryRoutes from "./inventory.routes";
import CouponRoutes from "./coupon.routes"
import CustomBillingRoutes from "./customBilling.routes";
import SupportRoutes from "./support.routes";
import SubcriptionRoutes from "./subscriptions.routes"
import Profileroutes from "./profile.routes"
import LoginInfoRoutes from "./loginInfo.routes"
import hotelRoutes from "./hotel.routes";
import EmployeeRoutes from "./employee.routes";
import HotelUserRoutes from "./hoteluser.routes"
import HotelProfileScreen from "../screens/HotelScreens/HotelProfileScreen";
import IntegrationRoutes from "../routes/integrations.routes"
import OutlateRoutes from "../routes/outlate.routes"
import HallRoutes from "../routes/hall.routes";
import SupplierRoutes from "../routes/supplier.routes"
import OutlateRoutes2 from "../routes/outlate2.routes"
import FeedbackRoutes from "../routes/feedback.routes"
import reportroutes from "./report.routes";
import CustomerRoutes from "./customer.routes";

import {
  ListCustomBillScreen,
  AddCustomBillScreen,DineInScreen,PaymentRequestScreen
} from "../screens/CustomBillingScreens";

import OrderHistoryScreen from "../screens/OrderScreens/OrderHistoryScreen";

// import { FloorRoutes } from ".";
import routes from "./URL";

const clipArts = [];

const switchRoutes = [
  {
    path: routes.admin.employees.root(":hotelSlug"),
    component: EmployeeRoutes,
  },
  {
    path: routes.admin.hotels.root,
    component: hotelRoutes,
  },
  {
    path: routes.admin.support.root(":hotelSlug"),
    component: SupportRoutes,
  },
  {
    path: routes.admin.subscriptions.root(":hotelSlug"),
    component: SubcriptionRoutes,
  },
  {
    path: routes.admin.profile.root(":hotelSlug"),
    component: Profileroutes,
  },
  {
    path: routes.admin.loginInfo.root(":hotelSlug",":username"),
    component: LoginInfoRoutes,
  },

  {
    path: routes.admin.customBilling.dineIn(":hotelSlug"),
    component: DineInScreen,
  },

  {
    path: routes.admin.customBilling.root,
    component: CustomBillingRoutes,
  },
  {
    path: routes.admin.inventory.root,
    component: InventoryRoutes,
  },
  {
    path: routes.admin.coupon.root(":hotelSlug"),
    component: CouponRoutes,
  },
  {
    path: routes.admin.gallery.root(":hotelSlug"),
    component: GalleryScreen,
  },
  {
    path: routes.admin.status.root(":hotelSlug"),
    component: StatusConfigScreen,
  },
  {
    path: routes.admin.tokenAmounts.root(":hotelSlug"),
    component: TaxTokenScreen,
  },
 {
    path: routes.admin.reports.root(":hotelSlug"),
    component: reportroutes,
  },

  {
    path: routes.admin.integrations.root(":hotelSlug"),
    component: IntegrationRoutes,
  },
    {
    path: routes.admin.supplier.root,
    component: SupplierRoutes,
  },
    {
    path: routes.admin.outlate.root,
    component: OutlateRoutes,
  },
      {
    path: routes.admin.outlet.root,
    component: OutlateRoutes2,
  },
  {
    path: routes.admin.kot.root(":hotelSlug"),
    component: KotRoutes,
  },
  {
    path: routes.admin.dashboard.root(":hotelSlug"),
    component: DashboardRoutes,
  },
  {
    path: routes.admin.floors.root(":hotelSlug"),
    component: FloorRoutes,
  },
  {
    path: routes.admin.halls.root(":hotelSlug"),
    component: HallRoutes,
  },
  {
    path: routes.admin.category.root(":hotelSlug"),
    component: categoryRoutes,
  },
  {
    path: routes.admin.menu.root(":hotelSlug"),
    component: MenuRoutes,
  },
  {
    path: routes.admin.orders.root(":hotelSlug"),
    component: OrderRoutes,
  },
  {
    path: routes.admin.orders.list(":hotelSlug"),
    component: OrderRoutes,
  },
  {
    path: routes.admin.orders.history(":hotelSlug"),
    component: OrderHistoryScreen,
  },

  // links.admin.payments.root
  // payment requests
  {
    path: routes.admin.payments.root(":hotelSlug"),
    component: PaymentRequestScreen,
  },

  {
    path: routes.admin.bookings.root(":hotelSlug"),
    component: BookingRoutes,
  },
  {
    path: routes.admin.users.root(":hotelSlug"),
    component: UsersRoutes,
  },
  {
    path: routes.admin.digitalToken.root(":hotelSlug"),
    component: digitalTokenRouts,
  },

  {
    path: routes.admin.settings.root,
    component: SettingRoutes, 
  },
    {
    path: routes.admin.customers.view(":hotelSlug",":customerSlug"),
    component: CustomerRoutes,
  },
  {
    path: routes.admin.customers.root(":hotelSlug"),
    component: UserListScreen,
  },

  {
    path: routes.admin.review.root(":hotelSlug"),
    component: FeedbackRoutes,
  },
  {
  path: routes.admin.qrCode.root(":hotelSlug"),
  component: QRCodeScreen,
},
  {
    path: routes.admin.timing.root(":hotelSlug"),
    component: TimingScreen,
  },
  {
    path: routes.admin.hotelusers.root,
    component: HotelUserRoutes,
  },
  {
    path: routes.root,
    // component: DashboardRoutes,
    // component: HotelProfileScreen,
    component: DashboardRoutes, //  <---  change this to HotelProfileScreen
  },

  // { path: routes.root, component: HotelRouts },
  {
    path: "*",
    component: NotFoundScreen,
  },
];

class AdminRoutes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      marginTop: 50,
    };
  }

  componentDidMount() {
    this.renderClipArts();
    //navigate user to select hotel screen if no hotel is selected
    if (this.props.selectedHotelId == null) {
      this.props.history.push(routes.root);
    }

    window.Echo.channel("hotel." + this.props.selectedHotelId.id).listen(
      ".hotel-events",
      this.hotelLister
    );

    window.Echo.channel("user." + this.props.userData.id).listen(
      ".user-events",
      this.userListner
    );
  }

  componentWillUnmount() {
    window.Echo.leave("hotel.orders." + this.props.selectedHotelId.id);
    window.Echo.leave("hotel.bookings." + this.props.selectedHotelId.id);
  }
  userListner = (e, cl) => {
    const { event, data } = e;
    switch (event) {
      case "user-access-control":
        this.props.openSnackbar("Access Control Updated");
        this.props.setAccessControl(data);
        break;
    }
  };
  hotelLister = (e, callback) => {
    console.log(e);
    // window.Alert("New Order Received");

    const { event, data } = e;
    switch (event) {
      case "order":
        this.props.openSnackbar("New Order Received:" + data.id);
        break;
      case "booking":
        this.props.openSnackbar("New Booking Received:" + data.id);
        break;
      default:
        break;
    }
  };

  renderClipArts = async () => {
    const height = window.innerHeight;
    const width = window.innerWidth;

    // randomaly sort clipArts array
    clipArts.sort(() => Math.random() - 0.5);

    clipArts.forEach((clipArt, index) => {
      //divide screen in grid and position images on it

      const img = new Image();
      img.src = clipArt;
      img.style.position = "absolute";
      img.style.top = Math.random() * height + "px";
      img.style.left = Math.random() * width + "px";
      img.style.width = " px";
      img.style.height = "100px";
      img.style.zIndex = -1;

      img.style.opacity = "0.04";
      document.body.appendChild(img);
    });
  };

  navigate = (path) => {
    this.props.history.push(path);
  };

  renderNavigationHelper() {
    const urlChunks = this.props.history.location.pathname.split("/");
    var filtered = [];
    var stopURLGeneration = false;

    for (var i = 0; i < urlChunks.length; i++) {
      if (!urlChunks[i]) continue;

      if (urlChunks[i] == "view" || urlChunks[i] == "edit")
        stopURLGeneration = true;

      var path = "";
      if (stopURLGeneration == false)
        for (let j = 0; j <= i; j++) {
          path += urlChunks[j] + "/";
        }

      filtered.push({
        name: urlChunks[i],
        path: path,
      });
    }

    var ret = filtered.map((item, index) => {
      return (
        <div
          key={index}
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            color: "grey",
          }}
        >
          <i className="fa fa-angle-right"></i>
          <span
            onClick={() => {
              //this.props.history.location.pathname upto current index

              if (item.path) this.navigate(item.path);
            }}
            style={{
              cursor: item.path ? "pointer" : "default",
              marginLeft: "10px",
              marginRight: "10px",
              color: "white",
              textDecoration: item.path ? "underline" : "none",
            }}
          >
            {" " + item.name + " "}
          </span>
        </div>
      );
    });

    return ret;
  }

  render() {
    return (
      <AdminNavigation props={this.props}>
        {/* //right content */}
        <div
          style={{
            // overflowX: "hidden",
            // maxHeight: "calc(100vh)",
            // overflowY: "auto",
          }}
        >
          {/* navigation */}
          {/* <div
                        style={{
                            // marginTop: "60px",
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            // backgroundColor: "white",
                            padding: "10px",
                            boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.2)",
                            fontSize: "17px",
                        }}
                    >
                        <div
                            onClick={() => {
                                this.navigate(routes.admin.dashboard.root);
                            }}
                            style={{
                                display: "flex",
                                flexDirection: "row",
                                alignItems: "center",
                                cursor: "pointer",
                                marginRight: "10px",
                            }}
                        >
                            <i
                                style={{ color: "white" }}
                                className="fa fa-home"
                            ></i>
                        </div>
                        {this.renderNavigationHelper()}
                    </div> */}

          {/* main content */}
          <div
            id="main-content"
            // style={{
            //   display: "flex",
            //   justifyContent: "center",
            //   alignItems: "center",
            //   marginTop:"170px"
              
            // }}
            className="container-fluid p-2"
          >
            <Switch>
              {switchRoutes.map((prop, key) => {
                return (
                  <Route
                    path={prop.path + "*"}
                    component={prop.component}
                    key={key}
                  />
                );
              })}
            </Switch>
          </div>

          <div style={{ height: 80 }} />
        </div>
      </AdminNavigation>
    );
  }
}

export default redux(AdminRoutes);
